import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/HomeView.vue";
import LoginView from "@/views/Auth/LoginView.vue";
import EnrollmentView from "@/views/Enrollment/EnrollmentView.vue";
import EditEnrollmentView from "@/views/Enrollment/EditEnrollmentView.vue";
import StudentInformationView from "@/views/StudentInformation/StudentInformationView.vue";
import AcademicProceduresListView from "@/views/AcademicProcedures/AcademicProceduresListView.vue";
import CreateAcademicProcedureView from "@/views/AcademicProcedures/CreateAcademicProcedureView.vue";
import EditAcademicProcedureView from "@/views/AcademicProcedures/EditAcademicProcedureView.vue";
import AcademicProcedurePaymentsListView from "@/views/AcademicProcedures/AcademicProcedurePaymentsListView.vue";
import PaymentSuccessView from "@/views/AcademicProcedures/PaymentSuccessView.vue";
import PaymentErrorView from "@/views/AcademicProcedures/PaymentErrorView.vue";
import notificationsUtility from "@/utilities/notifications-utility";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/enrollments",
    name: "enrollments",
    component: EnrollmentView,
  },
  {
    path: "/edit-enrollments/:enrollmentYear",
    name: "editEnrollments",
    component: EditEnrollmentView,
  },
  {
    path: "/student-information",
    name: "studentInformation",
    component: StudentInformationView,
  },
  {
    path: "/academic-procedures",
    name: "academicProcedures",
    component: AcademicProceduresListView,
  },
  {
    path: "/academic-procedures/create/:id",
    name: "createAcademicProcedure",
    component: CreateAcademicProcedureView,
  },
  {
    path: "/academic-procedures/:uuid/edit",
    name: "editAcademicProcedure",
    component: EditAcademicProcedureView,
  },
  {
    path: "/academic-procedures/:uuid/payments",
    name: "academicProcedurePayments",
    component: AcademicProcedurePaymentsListView,
  },
  // Payment redirection urls
  {
    path: "/payment/response/success",
    component: PaymentSuccessView,
    meta: {
      admin: true,
      student: true,
    },
  },

  {
    path: "/payment/response/error",
    component: PaymentErrorView,
    meta: {
      admin: true,
      student: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      publicPage: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("token");
  if (!to.meta.publicPage && !isLoggedIn) {
    notificationsUtility.pushNotification({
      message: "Log in required",
      type: "error",
    });
    if (from.name !== "login") {
      return next("/login");
    }
  }
  return next();
});

export default router;
